export default __webpack_public_path__ + "static/media/property-monetization.2e0d42fc.svg";